import Vue from "vue";
import i18n from './i18n'
import { extend, configure, ValidationProvider, ValidationObserver } from "vee-validate";

//NOTE - For more rules!
//LINK - https://vee-validate.logaretm.com/v3/guide/rules.html#rules
import { required, email, min, min_value, max_value, length, numeric, regex, ext, size } from "vee-validate/dist/rules";
extend('required', required)
extend('email', email)
extend('min', min)
extend('min_value', min_value)
extend('max_value', max_value)
extend('length', length)
extend('numeric', numeric)
extend('regex', regex)
extend('ext', ext)
extend('size', size)

configure({
  defaultMessage: (field, values) => {
    field = field.indexOf('|') > -1 ? field.split('|')[0] : field
    const translated_field = i18n.t(`fields.${field}`)
    return i18n.t(`validation.${values._rule_}`, { attribute: translated_field, ...values })
  }
})

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);